import type { CookieRef } from '#app';

export interface ICookie {
  version: String | string;
};

export interface ICookieConsent {
  version: String | string;
  consent: boolean;
  optional: {
    performance: boolean;
    advertisement: boolean;
  };
};

export interface ICookieData {
  version: String | string;
  data: Object;
  userData: Object;
};

export interface ICookies {
  base: CookieRef<ICookie>;
  consent: CookieRef<ICookieConsent>;
  data: CookieRef<ICookieData>;
};

export default defineNuxtPlugin({
  name: 'boot',
  dependsOn: [
    'nuxt:global-components',
    'nuxt:router',
    'nuxt-site-config:init'
  ],
  parallel: true,
  enforce: 'pre',
  async setup(nuxtApp: any) {
    const defaultCookie = <ICookie>{
      version: (useRuntimeConfig()?.public?.cookie?.version ?? '1.0')
    };
    const defaultConsentCookie = <ICookieConsent>{
      version: (useRuntimeConfig()?.public?.cookie?.version ?? '1.0'),
      consent: false,
      optional: {
        performance: false,
        advertisement: false
      }
    };
    const defaultDataCookie = <ICookieData>{
      version: (useRuntimeConfig()?.public?.cookie?.version ?? '1.0'),
      data: {},
      userData: {},
    };
    const cookie = useCookie<ICookieConsent>((useRuntimeConfig()?.public?.cookie?.name ?? 'zbl'), {
      default: () => (defaultCookie),
      sameSite: 'lax',
      maxAge: (60 * 60 * 24 * 31) // month
    });
    const consentCookie = useCookie<ICookieConsent>((useRuntimeConfig()?.public?.cookie?.nameConsent ?? 'zbl_consent'), {
      default: () => (defaultConsentCookie),
      sameSite: 'lax',
      maxAge: (60 * 60 * 24 * 31) // month
    });
    const dataCookie = useCookie<ICookieData>((useRuntimeConfig()?.public?.cookie?.nameData ?? 'zbl_data'), {
      default: () => (defaultDataCookie),
      sameSite: 'lax',
      maxAge: (60 * 60 * 24 * 31) // month
    });
    // New version release
    if ((cookie?.value == null) && (cookie?.version !== (useRuntimeConfig()?.public?.cookie?.version ?? '1.0')))
      cookie.value = defaultCookie;
    if ((consentCookie?.value == null) && (consentCookie?.version !== (useRuntimeConfig()?.public?.cookie?.version ?? '1.0')))
      consentCookie.value = defaultConsentCookie;
    if ((dataCookie?.value == null) && (dataCookie?.version !== (useRuntimeConfig()?.public?.cookie?.version ?? '1.0')))
      dataCookie.value = defaultDataCookie;
    // Result data
    const result = {
      base: cookie,
      consent: consentCookie,
      data: dataCookie
    } as ICookies;
    // Usage
    await nuxtApp.vueApp?.use({
      install(app: any, options: any) {
        app.provide('cookies', result as ICookies);
      }
    });
    // App
    if ((! useRuntimeConfig()?.public?.development) && import.meta.client)
      nuxtApp.hook('app:created', () => {
        console.log('%c  STOP!', 'font-weight: bold; font-size: 100px; color: red; text-shadow: 3px 3px 0 rgb(217,31,38) , 6px 6px 0 rgb(226,91,14) , 9px 9px 0 rgb(245,221,8) , 12px 12px 0 rgb(5,148,68) , 15px 15px 0 rgb(2,135,206) , 18px 18px 0 rgb(4,77,145) , 21px 21px 0 rgb(42,21,113)');
        let warningMessage = [
          'Toto je funkcia prehliadača určená pre vývojárov.',
          'Ak vám niekto povedal, aby ste sem niečo',
          'vložili a aktivovali tak to nerobte.',
          'Jedná sa o podvod, vďaka ktorému môže dotyčný',
          'získať prístup do vašeho účtu',
          'alebo spustiť škodlivý kód.'
        ].join('\n');
        console.log(`%c ${warningMessage}`, 'color: red; font-size: 20px');
      });

    return {
      provide: {
        cookies: result as ICookies
      }
    };
  },
  env: {
    islands: true
  }
});
